import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import TrialMessagingContent from "./TrialMessagingContent";

const MODAL_SEEN_KEY = "carthub_trial_welcome_modal_v1";

export function hasSeenTrialWelcomeModal() {
  try {
    return localStorage.getItem(MODAL_SEEN_KEY) === "1";
  } catch {
    return true;
  }
}

export function markTrialWelcomeModalSeen() {
  try {
    localStorage.setItem(MODAL_SEEN_KEY, "1");
  } catch {}
}

export default function TrialWelcomeModal({ open, onClose, variant, onGoToSubscription, welcomeFlow = false }) {
  const { t } = useTranslation("trial");
  const dlgRef = useRef(null);

  const dismiss = (persistSeen) => {
    if (persistSeen && welcomeFlow) markTrialWelcomeModalSeen();
    onClose();
  };

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    dlgRef.current?.focus?.();
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") {
        if (welcomeFlow) markTrialWelcomeModalSeen();
        onClose();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, welcomeFlow, onClose]);

  if (!open) return null;

  const overlay = {
    position: "fixed",
    inset: 0,
    background: "rgba(26,26,26,0.45)",
    zIndex: 1050,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
    boxSizing: "border-box",
  };

  const panel = {
    background: "#fff",
    borderRadius: 18,
    maxWidth: 520,
    width: "100%",
    maxHeight: "min(90vh, 640px)",
    overflow: "auto",
    boxShadow: "0 25px 50px rgba(0,0,0,0.15)",
    border: "1px solid rgba(26,26,26,0.08)",
  };

  return (
    <div style={overlay} onClick={() => dismiss(welcomeFlow)} role="presentation">
      <div
        ref={dlgRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="trial-welcome-title"
        tabIndex={-1}
        style={panel}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: "24px 24px 20px" }}>
          <h2 id="trial-welcome-title" style={{ margin: "0 0 8px", fontSize: 20, fontWeight: 700, color: "#1a1a1a", letterSpacing: "-0.02em" }}>
            {welcomeFlow ? t("modal.titleWelcome") : t("modal.titleInfo")}
          </h2>
          <p style={{ margin: "0 0 18px", fontSize: 13, color: "#6b7280" }}>{welcomeFlow ? t("modal.leadWelcome") : t("modal.leadInfo")}</p>
          <TrialMessagingContent variant={variant} onGoToSubscription={onGoToSubscription} />
        </div>
        <div
          style={{
            padding: "14px 24px 20px",
            display: "flex",
            flexWrap: "wrap",
            gap: 10,
            justifyContent: "flex-end",
            borderTop: "1px solid rgba(26,26,26,0.06)",
          }}
        >
          <button type="button" className="ch-btn" onClick={() => dismiss(welcomeFlow)} style={{ justifyContent: "center" }}>
            {welcomeFlow ? t("modal.ctaWelcome") : t("modal.ctaClose")}
          </button>
        </div>
      </div>
    </div>
  );
}

export { MODAL_SEEN_KEY };
